import type { SetupStepComponent } from '..'

import Section from '../../components/section'

const SetUpBotsStep: SetupStepComponent = () => (
  <Section
    titleKey="setupStep.setUpBots.title"
    textKey="setupStep.setUpBots.body"
  />
)

export default SetUpBotsStep
